import { Component, OnInit, Input } from '@angular/core';
import { Airport } from '../models/airport.model';
import {getSubTags, hasTag} from '../../util/tag-utils';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import { AirportService } from '../airport.service';
import { EditCampingComponent } from '../edit-camping/edit-camping.component';


@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  @Input() airport: Airport;
  @Input() isIslandSource: boolean;
  getSubTags = getSubTags;
  editModeSet: boolean;

  constructor( private _toggleService: EditToggleService,
               public _snackBar: MatSnackBar,
               private _editTransportationDialog: MatDialog,
               private _airportService: AirportService,
               private _editCampingDialog: MatDialog) {
  }

  ngOnInit() {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
  }

  get hasServices(): boolean {
    return getSubTags(this.airport.airportTags, 'Services::').length > 0
      || getSubTags(this.airport.airportTags, 'Transportation::').length > 0
      || getSubTags(this.airport.airportTags, 'Fuel::').length > 0
      || getSubTags(this.airport.airportTags, 'Customs::').length > 0
      || getSubTags(this.airport.airportTags, 'Activities::').length > 0
      || hasTag(this.airport.airportTags, 'Camping On Field');
  }

  async reloadAirport(identifier: string) {
    this.airport = await this._airportService.getAirport(identifier, true);
  }

  openEditTagsDialog(group: String[], except: String[], title: string): void {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      business: this.airport,
      tagsGroup: group,
      except: except,
      title: title
    };

    dialogConfig.width = '60%';
    const dialogRef = this._editTransportationDialog.open(EditTagsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isSuccess) => {
      if (isSuccess) {
        // this.loadAllTags();
        this.reloadAirport(this.airport.identifier);
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }

  getCampingOnFieldText(): string {
    let retString = 'None reported';
    if (hasTag(this.airport.airportTags, 'Camping On Field')) {
      retString = 'Available';
    }
    if (getSubTags(this.airport.airportTags, 'Camping On Field::Availability::').length > 0) {
      retString = '';
    }
    return retString;
  }

  getCampingAvailabilityText(): string {
    let retString = '';
    if (hasTag(this.airport.airportTags, 'Camping On Field::Availability::Year-Round')) {
      retString = 'Year-Round';
    }
    if (hasTag(this.airport.airportTags, 'Camping On Field::Availability::Seasonal')) {
      retString = 'Seasonal';
    }
    if (hasTag(this.airport.airportTags, 'Camping On Field::Availability::Special Events Only')) {
      retString = 'Special Events Only';
    }
    if (hasTag(this.airport.airportTags, 'Camping On Field::Availability::Reservation Required')) {
      retString += ', Reservation Required';
    }
    return retString;
  }

  openEditCampingDialog(): void {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      airport: this.airport
    };

    dialogConfig.width = '400px';
    const dialogRef = this._editCampingDialog.open(EditCampingComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isSuccess) => {
      if (isSuccess) {
        // this.loadAllTags();
        this.reloadAirport(this.airport.identifier);
      } else {
        this._snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
